import Axios, { AxiosPromise } from 'axios';
import { getNewDapiPath } from '../../../config/ConfigService';

const tryMigrateUser = (username: string): AxiosPromise<void> => {
  return Axios.post<void>(`${getNewDapiPath()}/v1/migrate/${username}`, undefined, {
    headers: {
      'cache-control': 'no-cache',
    },
  });
};

export { tryMigrateUser };
